import { Form, Spinner } from "react-bootstrap";

import { REGISTRATION_STATUS_OPTIONS } from "../utils/competitors.utils";

const CompetitorsFilters = ({
  showRallySelect = false,
  rallies = [],
  isRalliesLoading = false,
  selectedRallyId = "",
  onRallyChange,
  categories = [],
  isCategoriesLoading = false,
  selectedCategoryId = "",
  onCategoryChange,
  selectedStatus = "",
  onStatusChange,
}) => {
  return (
    <div className="d-flex flex-wrap align-items-end gap-3 mb-4">
      {showRallySelect ? (
        <Form.Group className="mb-0" style={{ minWidth: 220 }}>
          <Form.Label className="mb-1">Rally</Form.Label>
          <Form.Select
            value={selectedRallyId}
            onChange={(e) => onRallyChange(e.target.value)}
            disabled={isRalliesLoading}
          >
            <option value="">
              {isRalliesLoading ? "Loading rallies..." : "Select a rally"}
            </option>
            {rallies.map((rally) => {
              const id = rally._id || rally.id;
              return (
                <option key={id} value={id}>
                  {rally.name || "Untitled rally"}
                </option>
              );
            })}
          </Form.Select>
        </Form.Group>
      ) : null}

      <Form.Group className="mb-0" style={{ minWidth: 200 }}>
        <Form.Label className="mb-1">Category</Form.Label>
        <Form.Select
          value={selectedCategoryId}
          onChange={(e) => onCategoryChange(e.target.value)}
          disabled={isCategoriesLoading || (showRallySelect && !selectedRallyId)}
        >
          <option value="">
            {isCategoriesLoading ? "Loading categories..." : "All categories"}
          </option>
          {categories.map((category) => {
            const id = category._id || category.id;
            return (
              <option key={id} value={id}>
                {category.title || category.key || "Untitled category"}
              </option>
            );
          })}
        </Form.Select>
      </Form.Group>

      <Form.Group className="mb-0" style={{ minWidth: 180 }}>
        <Form.Label className="mb-1">Status</Form.Label>
        <Form.Select
          value={selectedStatus}
          onChange={(e) => onStatusChange(e.target.value)}
          disabled={showRallySelect && !selectedRallyId}
        >
          {REGISTRATION_STATUS_OPTIONS.map((option) => (
            <option key={option.value || "all"} value={option.value}>
              {option.label}
            </option>
          ))}
        </Form.Select>
      </Form.Group>

      {(isRalliesLoading || isCategoriesLoading) && (
        <Spinner animation="border" size="sm" className="mb-1" />
      )}
    </div>
  );
};

export default CompetitorsFilters;
